module.exports = __webpack_public_path__ + "img/slika8.0567d76c.jpg";